import React, { useEffect, useState } from "react";
import { LoaderComponent } from "../../component/LoaderComponent";
import { agentDataSelected } from "../../Redux/IntermediaryReducer";
import { typeOfCalculator } from "../../Redux/InsurerReducer";
import Tree from "../../assets/images/vector-smart-object-copy-7.png";
import { useNavigate } from "react-router-dom";
import { typeOfCal } from "../../Constant";
import { useIsMobile } from "../../Hooks/useIsMobile";
import { useDispatch } from "react-redux";
import axios from "axios";
import { decryptResponse, doEncryption, refA_refB_ParentAgencyId } from "../../utilities/lib";

const QPPOSLogin = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(false);
  const [qpData, setQpData] = useState();
  const isMobile = useIsMobile();
  const [refA, setRefA] = useState("");
  const [refB, setRefB] = useState("");
  const [refC, setRefC] = useState("");
  const [disbaleRefs, setDisableRef] = useState({refADisable: false, refBDisable: false})
  const [partnerName, setPartnerName] = useState("");
  const [selectedBranchId, setSelectedBranchId] = useState();
  const [selectedEmployee, setSelectedEmployee] = useState();
  const [selectedEmployeeCode, setSelectedEmployeeCode] = useState();
  const [partnerNameErr, setPartnerNameErr] = useState(false);
  const [selectedBranchIdErr, setSelectedBranchIdErr] = useState(false);
  const [selectedEmployeeErr, setSelectedEmployeeErr] = useState(false);
  const [selectedEmployeeCodeErr, setSelectedEmployeeCodeErr] = useState(false);
  const getAllData = () => {
    setShowLoader(true);
    const reqObj = {
      agentid: props.paramsData.agentId,
      intermedsubcatcd: props.paramsData.intermedsubcatcd,
      mobilenumber: props.paramsData.mobilenumber,
    }
    var config = {
      method: "post",
      url: process.env.REACT_APP_Base_Url + "intermediary/v1/getiamdata",
      headers: {
        "Content-Type": "application/json",
      },
      data: doEncryption(reqObj),
    };

    axios(config)
      .then(function (res) {
        if (res.data.response?.length == 0) {
          return
        }
        let response = decryptResponse(res.data.response)
        response = JSON.parse(response);
        setQpData(response);
        setShowLoader(false);
        if (refA_refB_ParentAgencyId.includes(response[0]?.parentagencyid)) {
          setDisableRef({ ...disbaleRefs, refADisable: response[0]?.refA?true:false, refBDisable: response[0]?.refB?true:false })
          setRefA(response[0]?.refA)
          setRefB(response[0]?.refB)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getAllData();
  }, []);

  const checkValidFields = () => {
    let errors = {};
    if (!partnerName) {
      setPartnerNameErr(true);
      errors["partnerName"] = true;
    }
    if (!selectedBranchId) {
      setSelectedBranchIdErr(true);
      errors["selectedBranchId"] = true;
    }
    if (!selectedEmployee) {
      setSelectedEmployeeErr(true);
      errors["selectedEmployee"] = true;
    }
    if (!selectedEmployeeCode) {
      setSelectedEmployeeCodeErr(true);
      errors["selectedEmployeeCode"] = true;
    }
    if (Object.keys(errors).length > 0) {
      return true;
    } else {
      return false;
    }
  };
  const onNextClick = () => {
    if (checkValidFields()) {
      return;
    }
    let data = qpData.find(
      (employeeData) => employeeData.employeeNameOrSPName == selectedEmployee
    );
    if (data) {
      data["businessFor"] = "partner";
      data["flowType"] = "advisor";
      data["skip"] = props.paramsData.skip;
      data["authorization"] = props.paramsData.authorization;
      data["refA"] = refA;
      data["refB"] = refB;
      data["refC"] = refC;
    }
    dispatch(agentDataSelected(data));
    if (props.paramsData.productName === "All Products") {
      navigate("/plan-selection");
    } else if (props.paramsData.productName === "Prohealth Prime") {
      navigate("/prohealth-prime");
      dispatch(typeOfCalculator(typeOfCal.prohealthPrime));
    } else if (props.paramsData.productName === "Lifetime Health") {
      navigate("/lifetime-health");
      dispatch(typeOfCalculator(typeOfCal.lifetime));
    } else if (props.paramsData.productName === "Prime Senior") {
      navigate("/prime-senior");
      dispatch(typeOfCalculator(typeOfCal.primeSenior));
    } else if (props.paramsData.productName === "Prohealth") {
      navigate("/prohealth-insurance");
      dispatch(typeOfCalculator(typeOfCal.prohealth));
    } else if (props.paramsData.productName === "Super Top Up") {
      navigate("/super-top-up");
      dispatch(typeOfCalculator(typeOfCal.superTopUp));
    } else if (props.paramsData.productName === "Critical Illness") {
      navigate("/critical-illness");
      dispatch(typeOfCalculator(typeOfCal.ci));
    } else if (props.paramsData.productName === "Personal Accident") {
      navigate("/personal-accident");
      dispatch(typeOfCalculator(typeOfCal.pa));
    } else if (props.paramsData.productName === "Accident Shield") {
      navigate("/accident-shield");
      dispatch(typeOfCalculator(typeOfCal.accident_Shield));
    } else if (props.paramsData.productName === "Sarvah") {
      navigate("/sarvah");
      dispatch(typeOfCalculator(typeOfCal.mchiSarvah));
    } else if (props.paramsData.productName === "Infinix") {
      navigate("/infinix");
      dispatch(typeOfCalculator(typeOfCal.infinix));
    }
  };

  const arrayPartnerNames =
    qpData &&
    qpData.length > 0 &&
    qpData.map((src, index) => {
      return (
        <option key={index} value={src.parentagencyname}>
          {src.parentagencyname}
        </option>
      );
    });

  const uniqueBranchIds = qpData &&
    qpData.length > 0 && [
      ...new Map(qpData.map((m) => [m.branchId, m])).values(),
    ];

  const arrayBranchIds =
    uniqueBranchIds &&
    uniqueBranchIds.length > 0 &&
    uniqueBranchIds.map((src, index) => {
      return (
        <option key={index} value={src.branchId}>
          {src.branchId}
        </option>
      );
    });

  const arrayFilteredEmployeeDetails =
    qpData &&
    qpData.length > 0 &&
    qpData.filter((qpData) => qpData.branchId == selectedBranchId);


  const arrayEmployeeDMSNames =
    arrayFilteredEmployeeDetails &&
    arrayFilteredEmployeeDetails.length > 0 &&
    arrayFilteredEmployeeDetails.map((src, index) => {
      return (
        <option key={index} value={src.employeeNameOrSPName}>
          {src.employeeNameOrSPName}
        </option>
      );
    });

  /** const arrayEmployeeDMSNames =
    qpData &&
    qpData.length > 0 &&
    qpData.map((src, index) => {
      return (
        <option key={index} value={src.employeeNameOrSPName}>
          {src.employeeNameOrSPName}
        </option>
      );
    }); */

  const arrayEmployeeDMSCodes =
    qpData &&
    qpData.length > 0 &&
    qpData.find((qpData) => qpData.employeeNameOrSPName == selectedEmployee);

  const handleSelectedBrandId = (value) => {
    setSelectedBranchId(value);
    setSelectedEmployee("");
    setSelectedEmployeeCode("");
  };

  const handleSelectedEmployee = (value) => {
    setSelectedEmployee(value);
  };

  const handleSelectedEmployeeCode = (value) => {
    setSelectedEmployeeCode(value);
  };

  return (
    <>
      {showLoader && <LoaderComponent />}
      {qpData?.length > 0 && (
        <div className="App">
          <div className="bg_blue mt-5">
            <div className="row mt-5">
              <div
                className={
                  isMobile ? "col-md-12 p-0 text-center" : "col-md-12 p-0"
                }
              >
                <div
                  class={isMobile ? "jumbotron" : "jumbotron pt-3 p-4 mt-5"}
                  style={{ marginTop: `${isMobile ? "80px" : "0px"}` }}
                >
                  <h3 class="text-white">
                    Welcome {qpData && qpData[0].employeeNameOrSPName}
                  </h3>
                  <p className="text-white">
                    DMS Code - {qpData && qpData[0].employeeCodeOrSPCode}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg_light_blue mt-4">
            <div className="container mt-5">
              <div className="row" style={{ marginTop: "-100px" }}>
                {/* <div className="col-md-3">
                <div className="card p-5 bg-orange ">
                  <div className="mb-2">
                    <label className="mb-2">
                      QP Name
                      <i className="text-white">*</i>
                    </label>
                    <h6 class="card-subtitle mb-2">
                      {qpData && qpData[0].agentName}
                    </h6>
                  </div>
                  <div className="mb-2">
                    <label className="mb-2">
                      QP Code
                      <i className="text-white">*</i>
                    </label>
                    <h6 class="card-subtitle mb-2">
                      {qpData && qpData[0].agentId}
                    </h6>
                  </div>
                  <div className="mb-2">
                    <label className="mb-2">Channel</label>
                    <h6 class="card-subtitle mb-2">
                      {qpData && qpData[0].channel}
                    </h6>
                  </div>
                </div>
              </div> */}
                <div>
                  <div className="card p-4">
                    <div class="container" style={{ display: "grid" }}>
                      <div class="row">
                        <div class="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Partner Name</b>
                              <i className="red">*</i>
                            </label>
                            <select
                              class="form-select"
                              aria-label="Default select example"
                              value={partnerName}
                              onChange={(e) => setPartnerName(e.target.value)}
                            >
                              <option option hidden selected>
                                Select
                              </option>
                              {/* {arrayPartnerNames} */}
                              <option>
                                {qpData && qpData[0].parentagencyname}
                              </option>
                            </select>
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!partnerName &&
                              partnerNameErr &&
                              "Please enter Partner Name"}
                          </div>
                        </div>
                        <div class="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Partner Branch Code</b>
                              <i className="red">*</i>
                            </label>
                            <select
                              class="form-select"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleSelectedBrandId(e.target.value)
                              }
                            >
                              <option hidden selected>
                                Select
                              </option>
                              {arrayBranchIds}
                            </select>
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedBranchId &&
                              selectedBranchIdErr &&
                              "Please enter Branch Code"}
                          </div>
                        </div>
                        <div class="col-md-4"></div>
                      </div>
                      <div class="row">
                        <div class="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Empolyee DMS Name</b>
                              <i className="red">*</i>
                            </label>
                            <select
                              class="form-select"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleSelectedEmployee(e.target.value)
                              }
                              value={selectedEmployee}
                            >
                              <option hidden selected>
                                Select
                              </option>
                              {arrayEmployeeDMSNames}
                            </select>
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedEmployee &&
                              selectedEmployeeErr &&
                              "Please enter Employee Name"}
                          </div>
                        </div>
                        <div class="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Empolyee DMS Code</b>
                              <i className="red">*</i>
                            </label>
                            <select
                              class="form-select"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleSelectedEmployeeCode(e.target.value)
                              }
                              value={selectedEmployeeCode}
                            >
                              <option hidden selected>
                                Select
                              </option>
                              {arrayEmployeeDMSCodes && (
                                <option>
                                  {arrayEmployeeDMSCodes.employeeCodeOrSPCode}
                                </option>
                              )}
                            </select>
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedEmployeeCode &&
                              selectedEmployeeCodeErr &&
                              "Please enter Employee Code"}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>MCHI Branch Code</b>
                              <i className="red">*</i>
                            </label>
                            <input
                              class="form-control disabled-input text-center"
                              type="text"
                              value={
                                arrayEmployeeDMSCodes &&
                                arrayEmployeeDMSCodes.mappedirdalocation
                              }
                              aria-label="Disabled input example"
                              disabled
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4 p-3">
                          <label className="mb-1">
                            <b>Ref A</b>
                          </label>
                          <textarea
                            class="form-control"
                            placeholder="Give description here"
                            id="floatingTextarea"
                            value={refA}
                            disabled={disbaleRefs.refADisable}
                            readOnly={disbaleRefs.refADisable}
                            {...(!disbaleRefs.refADisable && ({
                              onChange: (e) => setRefA(e.target.value)
                            }))}
                          ></textarea>
                        </div>
                        <div class="col-md-4 p-3">
                          <label className="mb-1">
                            <b>Ref B</b>
                          </label>
                          <textarea
                            class="form-control"
                            placeholder="Give description here"
                            id="floatingTextarea"
                            value={refB}
                            disabled={disbaleRefs.refBDisable}
                            readOnly={disbaleRefs.refBDisable}
                            {...(!disbaleRefs.refBDisable && ({
                              onChange: (e) => setRefB(e.target.value)
                            }))}
                          ></textarea>
                        </div>
                        <div class="col-md-4 p-3">
                          <label className="mb-1">
                            <b>Ref C</b>
                          </label>
                          <textarea
                            class="form-control"
                            placeholder="Give description here"
                            id="floatingTextarea"
                            value={refC}
                            onChange={(e) => setRefC(e.target.value)}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ background: "#f5f5f5" }}>
            <div className="fixed mt-3">
              <div className="row">
                <div className="col-6">
                  <img
                    src={Tree}
                    alt="vector-smart-object-copy-7"
                    className="tree-image"
                  />
                </div>
                <div className="col-6 text-right" style={{ top: "45px" }}>
                  <button
                    onClick={() => onNextClick()}
                    className="btn btn-primary-custom"
                  >
                    NEXT &nbsp;
                    <i className="fa fa-angle-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QPPOSLogin;
